import { Address } from 'viem';
import { Vote } from '../types/proposals';

export const formatVotes = (votes: any): Vote[] => {
  return votes.map((vote: any) => ({
    proposalId: vote.proposal_id,
    address: vote.voter,
    votingPower: Number(vote.weight) / Math.pow(10, 18), // Convert from "Wei" to Karrat
    // vote support looks like its:
    // 0 = against
    // 1 = for
    // 2 = abstain ?
    vote: vote.support === 0 ? 'no' : vote.support === 1 ? 'yes' : 'abstain',
    date: new Date(vote.created_at),
    reason: vote.reason,
    proposer: vote.proposer,
  }));
};

export const formatVotesValue = (value: string) => {
  return parseInt(value).toLocaleString();
};
